export const decodeVin = (vin: string): string => {
    const reO = /O/gi;
    const reI = /I/gi;
    const reQ = /Q/gi;
    const cleanVin = vin
        .replace(reO, '0')
        .replace(reI, '1')
        .replace(reQ, '0');
    return cleanVin;
};
